import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { LeadSource } from "views/leads-id/types";
import { ContactFormsSubmenuLeadSource } from "./types";

export const useEligibleContactFormSources = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["LEAD_SOURCES_LIST"],
    queryFn: () =>
      instance
        .get<{ items: LeadSource[] }>("/portal/v1/boom_crm/lead_sources")
        .then((res) => res.data)
  });

  const eligibleSources = useMemo<ContactFormsSubmenuLeadSource[]>(
    () =>
      (data?.items ?? [])
        .filter((source) => source.enable_contact_form)
        .map((source) => ({
          id: source.id,
          name: source.name,
          color: source.color
        })),
    [data]
  );

  return { eligibleSources, isLoading };
};
